<template>
  <div class="successscreen">
    <div class="panelheader border-blue">
      <div class="booker-title">Success</div>
    </div>
        
    <div class="body">
      
      <div class="big-tick">
        <i class="el-icon-fa-check-circle-o"></i>
      </div>

      <div class="ps-header">Payment Successful</div>
      <div class="ps-subheader">Payment Receipt</div>

      <ul class="receipt">
        <li>
          <div class="pr-left">Transaction ID</div>
          <div class="pr-right">uY3Rpb24gcmF</div>
        </li>
        <li>
          <div class="pr-left">Amount</div>
          <div class="pr-right">$50.00</div>
        </li>
        <li v-for="(value, key) in bookingData" :key="key">
          <div class="pr-left">{{key}}</div>
          <div class="pr-right">{{value.name || value}}</div>
        </li>
      </ul>

      <div class="ps-info">
        Your payment has been successful, please keep this receipt for your records.
        A copy has been sent to your email.
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "successscreen",
  props: ['bookingData'],
  data(){
    return {}
  },
  computed: {
    randID: function(){
      return btoa(Math.random.toString()).slice(3, 15);
    }
  }
}
</script>

<style>

  .big-tick {
    color: green;
    margin: 30px auto;
  }

  .big-tick > i {
    font-size: 600% !important;
  }

  .ps-header {
    font-size: 125%;
    font-weight: bold;
    color: #4E2121;
  }

  .ps-subheader {
    font-size: 120%;
    color: #C9C9C9;
    margin: 10px;
  }

  .ps-info {
    font-size: 120%;
    width: 60%;
    color: #C9C9C9;
    margin: 20px auto;
  }

  .receipt {
    list-style-type: none;
    width: 35%;
    margin: 20px auto;
    padding: 0;
    border-bottom: 1px solid #F3F3F5;
  }

  .receipt > li {
    clear: both;
    padding: 8px;
    border: 1px solid #F3F3F5;
    border-bottom: 0;
    overflow: hidden;
  }

  .pr-left {
    float: left;
    font-weight: bold;
    text-transform: capitalize;
  }

  .pr-right {
    float: right;
  }

</style>



// WEBPACK FOOTER //
// SuccessScreen.vue?1e6f7f1e